import { render, staticRenderFns } from "./UserSettingsForm.vue?vue&type=template&id=63d7fc2d"
import script from "./UserSettingsForm.vue?vue&type=script&lang=js"
export * from "./UserSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports